<template>
  <div class="dropdown color-select">
    <button
      ref="toggle"
      type="button"
      class="color-select-trigger"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      title="Choose group color"
    >
      <span
        class="color-select-swatch"
        :style="{ background: modelValue || defaultColor }"
      ></span>
      <span class="color-select-badge">
        <i class="fas fa-chevron-down"></i>
      </span>
    </button>
    <div class="dropdown-menu color-select-menu">
      <div class="color-select-header">Group color</div>
      <div class="color-select-grid">
        <button
          v-for="option in options"
          :key="option.value"
          type="button"
          class="dropdown-item color-swatch-item"
          :style="{ background: option.value }"
          :title="option.label"
          @click="select(option.value)"
        >
          <i v-if="option.value === modelValue" class="fas fa-check"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { GROUP_COLOR_OPTIONS, DEFAULT_GROUP_COLOR } from "./groupColors";

export default {
  name: "group-color-picker",
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      options: GROUP_COLOR_OPTIONS,
      defaultColor: DEFAULT_GROUP_COLOR,
    };
  },
  methods: {
    select(value) {
      this.$emit("update:modelValue", value);
      window.$(this.$refs.toggle).dropdown("hide");
    },
  },
};
</script>

<style scoped lang="scss">
.color-select-trigger {
  position: relative;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;

  // This is a dropdown-toggle-less trigger (see template) so there's no
  // default Bootstrap caret to remove, but keep this as a guard in case
  // that class is ever reintroduced.
  &::after {
    display: none;
  }

  &:hover,
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.08);
  }

  &:hover .color-select-swatch,
  &:focus .color-select-swatch {
    transform: scale(1.1);
  }

  &:hover .color-select-badge,
  &:focus .color-select-badge {
    background: var(--light);
  }
}

.color-select-swatch {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
  transition: transform 0.15s ease;
}

// A small avatar-style "edit" badge in the corner — signals the swatch is
// clickable/changeable without bringing back Bootstrap's plain caret.
.color-select-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--white);
  border: 1px solid var(--light);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease;

  i {
    font-size: 7px;
    color: var(--gray-dark);
  }
}

.color-select-menu {
  // Bootstrap's own .dropdown-menu { display: none; } must stay in effect
  // until its JS adds .show — only override display once that's present.
  &.show {
    display: block;
  }
  padding: 10px;
  min-width: 168px;
  // Bootstrap's default .dropdown-menu z-index (1000) can still end up
  // behind later-painted siblings (e.g. the group cards list right after
  // this form) depending on ancestor stacking contexts — match Bootstrap's
  // own popover tier (1060) so this always paints on top.
  z-index: 1060;
}

.color-select-header {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--gray);
  margin-bottom: 8px;
  padding: 0 2px;
}

.color-select-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.color-swatch-item {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 0;
  padding: 0;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 10px;
  transition: transform 0.15s ease;

  &:hover {
    transform: scale(1.1);
  }
}
</style>
